module.exports = __webpack_public_path__ + "img/icon-sti.f1a41064.svg";